import React, { Dispatch, ReactNode, createContext, useContext, useMemo, useReducer } from 'react';
import type {Bot} from './bot-loaders'

type Action =  { type: 'setBots'; payload: Bot[] } |
 { type: 'updateBot'; payload: Bot } | 
 { type: 'setNeedsLogin'; payload: boolean } |
 { type: 'setSelectedBot'; payload: number } |
 { type: 'setSession'; payload: Session } 

function updateBot(bots:Bot[], bot:Bot):Bot[]{
    return bots.map( b => b.id == bot.id ? bot : b);
}


const reducer = (state: State, action: Action): State => {
    switch (action.type) {
      case 'setBots':
        return { ...state, bots: action.payload };
      case 'updateBot':
        return { ...state, bots: updateBot(state.bots, action.payload) };
      case 'setNeedsLogin':
          return { ...state, needsLogin: action.payload };
      case 'setSelectedBot':
        return { ...state, selectedBot: action.payload };
      case 'setSession':
          return { ...state, session: action.payload };
     
      default:
        return state;
    }
  };

interface State {
    selectedBot?: number
    bots?: Bot[]
    needsLogin?: boolean
    session?: {
      user: { email: string, name: string },
      account: { id: number, name: string }
    }
}

export type Session = State['session'];

export const BotStore = createContext<{ state: State; dispatch?: Dispatch<Action> }>({state: {}});

export function BotStoreProvider({ children }:{children:ReactNode}){
    const [state, dispatch] = useReducer(reducer, {});
  
    return <BotStore.Provider value={{ state, dispatch }}>
        {children}
    </BotStore.Provider>
};

export function useBot(bot:number){
  const {state} = useContext(BotStore);
  return useMemo(() =>{
      return state.bots.find(b => b.id == bot)
  }, [bot]);
}